import { colors } from '@ardoq/design-tokens';
import { SpeechBubbleContainer, SpeechBubbleText } from '../atoms';
import { SpeechBubbleProps } from '../types';
import { getSpeechBubblePath, getSpeechBubbleSize } from '../utils';

// yes, this is just a copy of SpeechBubble.tsx with the fill color changed.
// why didn't I just make the fill color a parameter?
// because the design team wants to treat these as distinct graphics, now and in the future.
// they do not want parameterized colors.
// but imagine some day they want to make a thought bubble, or a scream bubble... that is why they want distinct SVG assets for every variation of the speech bubble.

const PurpleSpeechBubble = ({ title, layout }: SpeechBubbleProps) => (
  <SpeechBubbleContainer $layout={layout}>
    <svg {...getSpeechBubbleSize(layout)} role="presentation">
      <path d={getSpeechBubblePath(layout)} fill={colors.purple15} />
    </svg>
    <SpeechBubbleText $layout={layout}>{title}</SpeechBubbleText>
  </SpeechBubbleContainer>
);

export { PurpleSpeechBubble };
